var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJoyLight = function SvgJoyLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 12,
    viewBox: "0 0 45 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.833 7.6134C19.833 8.86533 20.9254 9.95805 22.3719 9.95805C23.8185 9.95805 24.9109 8.86533 24.9109 7.6134H26.4394C26.4394 9.79549 24.574 11.4866 22.3719 11.4866C20.1698 11.4866 18.3044 9.79549 18.3044 7.6134H19.833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45416 3.22955C5.45416 2.25987 4.64844 1.41349 3.58154 1.41349C2.51464 1.41349 1.70892 2.25987 1.70892 3.22955L0.581542 3.22955C0.581543 1.5394 1.95737 0.229553 3.58154 0.229553C5.20572 0.229554 6.58154 1.5394 6.58154 3.22955L5.45416 3.22955Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4542 3.22955C43.4542 2.25987 42.6484 1.41349 41.5815 1.41349C40.5146 1.41349 39.7089 2.25987 39.7089 3.22955L38.5815 3.22955C38.5815 1.5394 39.9574 0.229553 41.5815 0.229553C43.2057 0.229554 44.5815 1.5394 44.5815 3.22955L43.4542 3.22955Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoyLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/joy_light.d9878aaf.svg";
export { ForwardRef as ReactComponent };